import React from "react";
import { Button, Card, Spinner } from "react-bootstrap";
import ReactEcharts from "echarts-for-react";
import { useTranslation } from "react-i18next";

const style = {
  height: "320px",
  width: "100%",
};

export default function TaskPeriodPieChart({ data, isLoading, onOpenTasks }) {
  const { t } = useTranslation();

  const chartData = [
    { key: "today", name: t("task_filter_today"), value: Number(data?.today || 0) },
    { key: "this_week", name: t("task_filter_this_week"), value: Number(data?.this_week || 0) },
    {
      key: "this_month",
      name: t("task_filter_this_month"),
      value: Number(data?.this_month || 0),
    },
    { key: "overdue", name: t("task_filter_overdue"), value: Number(data?.overdue || 0) },
  ];

  const total = chartData.reduce((sum, entry) => sum + entry.value, 0);
  const pieData = chartData.filter((entry) => entry.value > 0);

  const option = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      show: false,
    },
    series: [
      {
        name: t("tasks"),
        type: "pie",
        radius: ["58%", "88%"],
        center: ["50%", "48%"],
        avoidLabelOverlap: true,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: pieData,
      },
    ],
  };

  return (
    <Card className="dashboard-panel">
      <Card.Header className="dashboard-panel-header">
        <h6 className="mb-0">{t("dashboard.tasks_by_due_period")}</h6>
        <Button
          variant="outline-primary"
          size="sm"
          className="dashboard-tasks-open-btn"
          onClick={onOpenTasks}
        >
          {t("dashboard.view_tasks")}
        </Button>
      </Card.Header>
      <Card.Body>
        {isLoading ? (
          <div className="dashboard-empty">
            <Spinner animation="border" size="sm" className="me-2" />
            {t("loading")}
          </div>
        ) : total === 0 ? (
          <div className="dashboard-empty">{t("no_tasks")}</div>
        ) : (
          <>
            <ReactEcharts option={option} style={style} notMerge />
            <div className="dashboard-health-overview">
              <div className="dashboard-health-title">{t("task_filter_due_period")}</div>
              <div className="dashboard-task-period-list">
                {chartData.map((entry) => {
                  const percentage = total > 0 ? Math.round((entry.value / total) * 100) : 0;
                  return (
                    <div key={entry.key} className="dashboard-task-period-item">
                      <span className="dashboard-task-period-label">{entry.name}</span>
                      <span className="dashboard-task-period-value">
                        {entry.value} ({percentage}%)
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
}
